export default {
	footers(state) {
		return state.footers
	},
}
